"use client";
import React, { useEffect, useRef } from 'react';
import PropTypes from "prop-types";
import { Col, Container, Row } from "react-bootstrap";
import useDeviceType from "@/src/hooks/useDeviceType.jsx";
import Title from "@/src/components/common/ui/text/Title.jsx";
import reactHtmlParser from "react-html-parser";
import { Img } from '@/src/components/common/ui/images/Img.jsx';
import ReactPlayer from 'react-player';
import VideoPlayer from '@/src/components/common/eco/sections/banner/VideoPlayer.jsx';

const SlideOne = ({title, subTitle,
					  description,
					  bannerLarge,
					  buttonLink,
					  video,total
				  }) => {
	const { isMobile } = useDeviceType();
	// Use refs to store navigation buttons instead of direct DOM queries
	const navLeftRef = useRef(null);
	const navRightRef = useRef(null);

	useEffect(() => {
		if (typeof window === 'undefined') return; // Skip on server

		// Use refs and React event system, but fallback if needed
		const prevButton = document.querySelector(".swiper-button-prev");
		const nextButton = document.querySelector(".swiper-button-next");

		const handlePrevClick = () => prevButton?.click();
		const handleNextClick = () => nextButton?.click();

		const navLeft = navLeftRef.current;
		const navRight = navRightRef.current;

		if (navLeft && navRight) {
			navLeft.addEventListener("click", handlePrevClick);
			navRight.addEventListener("click", handleNextClick);
		}

		return () => {
			if (navLeft) navLeft.removeEventListener("click", handlePrevClick);
			if (navRight) navRight.removeEventListener("click", handleNextClick);
		};
	}, [buttonLink]);

	return (
		<>
			<div className="slide-inner">

					{video ? (
						<div className={'global-image next-video-bg'}>
							<VideoPlayer bannerLarge={bannerLarge} />
							{/*<video poster={bannerLarge} src={bannerLarge ? bannerLarge : '/images/video.mp4'} autoPlay muted loop playsInline />*/}
						</div>
					) : (
						<Img alt={title} src={bannerLarge} />
					)}

				<Container>

					<Row>
						<Col md={12}>
							<div className="slide-inner__info">
								<div className="side-wrapper">
									<div className="title-wrapper-middle">
										<Title
											tag={'h2'}
											animClass={'anim-text'}
											classname={`swiper__title`}
											text={title}
											color={"#fff"}
											margin={"0 "}
										/>
										<Title
											tag={'h2'}
											animClass={'anim-text'}
											classname={`swiper__title`}
											text={subTitle}
											color={"#fff"}
											margin={"0 "}
										/>
									</div>
								</div>
							</div>
						</Col>
					</Row>
					<Row className={'subDetails'}>
						<Col md={5}>
							<div className="slide-inner__info">
								<div className="side-wrapper">
									<div className="middle-description">
										<p className={'anim-text'}>{reactHtmlParser(description)}</p>
									</div>

								</div>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		</>
	);
};

SlideOne.propTypes = {
	subTitle: PropTypes.string,
	title: PropTypes.string,
	classname: PropTypes.string,
	content: PropTypes.string,
	thumb: PropTypes.string,
};

export { SlideOne };
